import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useTranslation } from "common/locales";

interface Props {
  disabled: boolean;
  date: Date | null;
  setDate: (date: Date | null) => void;
  dateError: boolean;
  name: string;
}

export default function EnterDate({
  disabled,
  date,
  setDate,
  dateError,
  name,
}: Props) {
  const { t } = useTranslation();

  const handleDateChange = (d: Date | null) => {
    setDate(d);
  };
  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.preventDefault();
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        disabled={disabled}
        disableFuture
        format="MMMM do yyyy"
        label={t("addDate.enterTime.dateLabel")}
        value={date}
        onChange={handleDateChange}
        slotProps={{
          textField: {
            onKeyDown,
            variant: "standard",
            error: dateError,
            name,
          },
        }}
      />
    </LocalizationProvider>
  );
}
